module.exports = __webpack_public_path__ + "static/media/pencil_outline.251cbecf.svg";